import {
    Box,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuItemOption,
    MenuGroup,
    MenuOptionGroup,
    MenuDivider,
    Button,
    Text,
    Tooltip,
    HStack,
    VStack,
    Collapse
} from '@chakra-ui/react';
import mapboxgl from 'mapbox-gl';
import React, { useContext, useEffect, useRef, useState } from 'react';
import MapContext from '../../context/MapContext';
import CompassControl from '@mapbox-controls/compass';
import RulerControl from '../../utils/mapbox/ruler';
import ZoomControl from '@mapbox-controls/zoom';
import { MapContextMenu } from './MapContextMenu';
import UIContext from '../../context/UIContext';
import { useHistory, useLocation } from 'react-router-dom';
import useIsDemo from '../../hooks/useIsDemo';
import useIsChartCoverageDemo from '../../hooks/useIsChartCoverageDemo';
// import 'mapbox-gl-inspect/dist/mapbox-gl-inspect.css';
// import MapboxInspect from 'mapbox-gl-inspect';
import * as turf from "@turf/turf";
import { Icon } from '@blueprintjs/core';
import MobileToolbar from '../mobileToolbar/MobileToolbar';
import cx from 'classnames';
import ElevationChart from '../ElevationChart';
import { useLocalStorage } from 'react-use';

function MeasureDisplay() {
    const {
        rulerControlRef,
        measureState,
        elevationState
    } = useContext(MapContext);
    const [elevationGraphVisible, setElevationGraphVisible] = useLocalStorage('show-elevation', true);

    const elevationSamples = [[], [], [], [], []];
    let lastSampleType = null;
    if (elevationState?.samples) {
        for (const sample of elevationState?.samples) {
            const thisSampleType = sample['height_msl'] >= 0 ? 'land' : 'water';
            // if (lastSampleType != thisSampleType) {
            //     // Duplicate 
            //     elevationSamples[2].push(sample['height_msl']);
            // } else {
            //     elevationSamples[2].push(null);
            // }

            elevationSamples[0].push(sample['distance_along']);
            if (sample['height_msl'] >= 0) {
                elevationSamples[1].push(sample['height_msl']);
                if (lastSampleType == 'water') {
                    elevationSamples[2].push(sample['height_msl']);
                } else {
                    elevationSamples[2].push(null);
                }
                lastSampleType = 'land';
            } else {
                elevationSamples[2].push(sample['height_msl']);
                if (lastSampleType == 'land') {
                    elevationSamples[1].push(sample['height_msl']);
                } else {
                    elevationSamples[1].push(null);
                }
                lastSampleType = 'water';
            }
            elevationSamples[3].push(0);
            elevationSamples[4].push(Math.min(0, sample['height_msl']));
        }
    } else {
        elevationSamples[0].push(0);
        elevationSamples[1].push(null);
        elevationSamples[2].push(null);
        elevationSamples[3].push(0);
        elevationSamples[4].push(null);
        elevationSamples[0].push(1000);
        elevationSamples[1].push(null);
        elevationSamples[2].push(null);
        elevationSamples[3].push(0);
        elevationSamples[4].push(null);

    }

    return (
            <Box    
                pointerEvents="auto"
                zIndex={20}
                display="flex"
                flexDir="column"
                justifyContent="stretch"
                alignItems="stretch"
                bg="rgba(255,255,255,0.9)"
                borderRadius="4px"
                border="1px solid rgba(0,0,0,0.1)"
                shadow="md"
                padding="0px"
                overflow="hidden"
                boxShadow={'0px 0px 0px 2px rgba(0,0,0,0.1)'}
                position="relative"
                minW="450px"
            >
                <HStack spacing={1} p="10px">
                    <Text fontWeight="500">Measure Tool</Text>
                    <Text>-</Text>
                    <Text>Click to add points</Text>
                </HStack>
                <Box 
                    bg="rgba(0,0,0,0.05)" w="100%"
                    borderTop="1px solid rgba(0,0,0,0.1)"
                    borderBottom={elevationGraphVisible && "1px solid rgba(0,0,0,0.1)"}
                    p="8px"
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <Text flex="0 0 auto" mr="10px"  fontFamily="monospace" fontWeight="600" fontSize="14px">{measureState.totalDistance || '0m'}</Text>
                    <Text flex="0 0 auto" fontFamily="monospace" fontWeight="600" fontSize="14px" opacity="0.6">({measureState.coordinates.length} point{measureState.coordinates.length != 1 && 's'})</Text>
                    <Button
                    onClick={() =>setElevationGraphVisible(!elevationGraphVisible)}
                    size="sm"
                    variant="ghost"
                    position="absolute"
                    right="0px"
                    _hover={{
                        bg: 'none'
                    }}
                    _active={{
                        bg: 'none'
                    }}
                    >   
                        <Text opacity="0.5" ml="4px" mr="4px"><Icon icon={elevationGraphVisible ? "timeline-line-chart" : "timeline-line-chart"}></Icon></Text>
                        {elevationGraphVisible ? 'Hide' : 'Show'} Elevation
                    </Button>
                </Box>
                <Box position="relative">
                    {elevationGraphVisible && !elevationState?.samples && (
                        <Box zIndex={1}
                        position="absolute"
                        top="0px"
                        bottom="0px"
                        left="0px"
                        right="0px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        bg="rgba(245,245,245,0.8)"
                        >
                            <VStack spacing={0}>
                                <Text color="black" opacity="0.2"><Icon icon="mountain" size="48"></Icon></Text>
                            <Text opacity="0.8">No elevation profile</Text>
                            <Text>Add two or more measurement points.</Text>
                            </VStack>
                        </Box>
                    )}
                    <Collapse in={elevationGraphVisible}>
                    <ElevationChart data={elevationSamples} />
                    </Collapse>
                </Box>
                <Tooltip placement="right" label={<Text>Deselect</Text>}>
                    <Button
                        _hover={{
                            color: 'rgba(0,0,0,1.0)',
                        }}
                        bg={''}
                        w="40px"
                        h={'40px'}
                        position="absolute"
                        top="0px"
                        right="0px"
                        onClick={() => {
                            rulerControlRef.current.measuringOff();
                        }}
                        color={'rgba(0,0,0,0.8)'}
                    >
                        <Text mb="0px">
                            <Icon icon={'cross'} size="16" />
                        </Text>
                    </Button>
                </Tooltip>
            </Box>
    )
}

export default MeasureDisplay;